module.exports = __webpack_public_path__ + "static/img/boatEast.a48e9c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/boatEast.png
// module id = 87Za
// module chunks = 3